import * as React from 'react';
import { Icon, IconProps } from 'src/icons/Icon';

export function WhatsAppIcon(props: IconProps): React.ReactElement {
    return <Icon character={'!'} {...props} />;
}
